import { NumberFormat } from '@interxfi/design-system/components/format/number';
import { Pill } from '@interxfi/design-system/components/pill';
import { Typography } from '@interxfi/design-system/components/typography';
import { useOpenCaseCount } from './use-open-case-count';

export function InboxStatusBadge() {
  const { count, pageSize } = useOpenCaseCount();
  if (!count) {
    return null;
  }

  return (
    <Pill variant="dark">
      <Typography lineHeight="1.25rem" size="0.75rem">
        {<NumberFormat value={count} withoutTypography />}
        {count >= pageSize ? '+' : ''}
      </Typography>
    </Pill>
  );
}
